const mutations = {
  setErrorLogs: (state, data) => {
    state.error_logs = data;
  },
};

export default mutations;
